export default "__VITE_ASSET__CnKwK61o__"